export default "__VITE_ASSET__CS2hJnl6__"